export async function uploadMedia(file: File) {
    const imageData = new FormData()
    imageData.append('file', file)

    try {
        const req = await fetch(`${process.env.NEXT_PUBLIC_BASE_URL}/api/media`, {
            method: 'POST',
            credentials: 'include',
            body: imageData,
        })
        const data = await req.json()
        return data.doc.id
    } catch (err) {
        console.log(err)
        throw err
    }
}

export async function createNewProduct(productData: { name: string; description: string; price: number }) {
    try {
        const req = await fetch(`${process.env.NEXT_PUBLIC_BASE_URL}/api/products`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(productData),
        })
        const data = await req.json()
        return data.doc.id
    } catch (err) {
        console.log(err)
        throw err
    }
}

export async function createNewAccessory(accessoryData: { name: string; description: string; price: number }) {
    try {
        const req = await fetch(`${process.env.NEXT_PUBLIC_BASE_URL}/api/accessories`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(accessoryData),
        })
        const data = await req.json()
        return data.doc.id
    } catch (err) {
        console.log(err)
        throw err
    }
}


export async function updateProductImages(productId: string, imageIds: string[]) {
    try {
        const req = await fetch(`${process.env.NEXT_PUBLIC_BASE_URL}/api/products/${productId}`, {
            method: "PATCH",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                images: imageIds.map(id => ({
                    image: id
                }))
            }),
        })
        const data = await req.json()
        return data
    } catch (err) {
        console.log(err)
        throw err
    }
}

export async function updateAccessoryImages(accessoryId: string, imageIds: string[]) {
    try {
        const req = await fetch(`${process.env.NEXT_PUBLIC_BASE_URL}/api/accessories/${accessoryId}`, {
            method: "PATCH",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                images: imageIds.map(id => ({
                    image: id
                }))
            }),
        })
        const data = await req.json()
        return data
    } catch (err) {
        console.log(err)
        throw err
    }
}

export async function getCategories() {
    const req = await fetch(`${process.env.NEXT_PUBLIC_BASE_URL}/api/categories`)
    const data = await req.json()
    return data.docs
}

export async function getSubCategories() {
    const req = await fetch(`${process.env.NEXT_PUBLIC_BASE_URL}/api/subcategories`)
    const data = await req.json()
    return data.docs
}

export async function getTags() {
    const req = await fetch(`${process.env.NEXT_PUBLIC_BASE_URL}/api/tags`)
    const data = await req.json()
    return data.docs
}
